import React, { useState } from "react"
import classnames from "classnames"
import ChevronRightIcon from "../../content/assets/svg/chevron-right.svg"

const MobileSidebarNavigationContainer = ({ children, title }) => {
  const [open, setOpen] = useState(false)

  return (
    <nav className="mobile-sidebar-navigation">
      <button
        className={classnames("nav-toggle", {
          open,
        })}
        onClick={() => setOpen(!open)}
      >
        {title}
        <ChevronRightIcon />
      </button>
      {open && children}
    </nav>
  )
}

export default MobileSidebarNavigationContainer
